import { HandleRingpool } from "./handleRingpool";
import { desActivarBTNSubmit, activarSubmitBtn } from "./handleBTNSubmit";
import { handleMoreText } from "./handleMoreText";
import { handleTestJourney } from "./handleTestJourney";
import { clickBotonDeshabilitado } from "./handleBtnDeshabilitado";
import { gestionarEmpresas } from "../../function/gestionarEmpresas";
import { implementaValorEnTodosLosForm } from "./implementaValorEnTodosLosForm";
import { handleCheckboxChange } from "./handleCheckboxChange";

//Variable global que se encarga de la activacion del botón, por como está montado ahora mismo
//el valor de este viene desde entornoMapfreSP.js (index.js) y se setea en validacion()
let ActivadorBTN;

function validarJubilacion(element) {
    const fechaActual = new Date();
    const fechaSeleccionada = new Date(element.value);

    const diff = fechaActual - fechaSeleccionada;
    const anhio = Math.trunc(diff / (1000 * 60 * 60 * 24 * 365));

    if (anhio >= 65) {
        return true
    };

    return false;
}

function validarTelefono(value) {

    let expresion_regular = /^[76]{1}[0-9]{8}$/gm;

    if (expresion_regular.test(value)) {
        return true;
    }

    return false;
}

function validarEmail(value) {

    let expresion_regular_email = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (expresion_regular_email.test(value)) {
        return true;
    }

    return false;
}

function validarCp(value) {

    var numeroPostal = value;
    var expresionRegular1 = /^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/;//<--- con esto vamos a validar el numero
    var expresionRegular2 = /\s/;//<--- con esto vamos a validar que no tenga espacios en blanco
    var provincias = ["ARABA/ALAVA", "Albacete", "Alicante", "Almeria", "Avila", "Badajoz", "Baleares", "Barcelona", "Burgos", "Caceres", "Cadiz", "Castellon", "Ciudad Real", "Cordoba", "Coruña", "Cuenca", "Gerona", "Granada", "Guadalajara", "Guipuzcoa", "Huelva", "Huesca", "Jaen", "Leon", "Lerida", "La Rioja", "Lugo", "Madrid", "Malaga", "Murcia", "Navarra", "Orense", "Asturias", "Palencia", "Las Palmas", "Pontevedra", "Salamanca", "Santa Cruz De Tenerife", "Cantabria", "Segovia", "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia", "Valladolid", "BIZKAIA", "Zamora", "Zaragoza", "Ceuta", "Melilla"]

    if (numeroPostal === '') {
        return false;
    } else if (expresionRegular2.test(numeroPostal)) {
        return false;
    } else if (!expresionRegular1.test(numeroPostal)) {
        return false;
    } else {
        var codigoProvincia = parseInt(numeroPostal.substring(0, 2)) - 1;
        if (codigoProvincia < 52) {

            // $('#Provincia, #Provincia1, #Provincia2').val(provincias[codigoProvincia]);
            var provinciasElements = document.querySelectorAll('#Provincia, #Provincia1, #Provincia2');

            if (!provinciasElements) return true;

            provinciasElements.forEach(function (element) {
                element.value = provincias[codigoProvincia];
            });

            return true;

        } else {
            // $('#Provincia, #Provincia1, #Provincia2').val("Madrid");
            var provinciasElements = document.querySelectorAll('#Provincia, #Provincia1, #Provincia2');

            if (!provinciasElements) return false;

            provinciasElements.forEach(function (element) {
                element.value = "Madrid";
            });
            return false;
        }
    }
}

function validarNombreApellido(value) {

    let expresion_regular_nombre = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g;

    if (expresion_regular_nombre.test(value)) {
        return true;
    }

    return false;
}

function validarDniNie(value) {

    let number, dni, letter;
    let expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;
    value = value.toUpperCase();
    if (expresion_regular_dni.test(value) === true) {
        number = value.substr(0, value.length - 1);
        number = number.replace('X', 0);
        number = number.replace('Y', 1);
        number = number.replace('Z', 2);
        dni = value.substr(value.length - 1, 1);
        number = number % 23;
        letter = 'TRWAGMYFPDXBNJZSQVHLCKET';
        letter = letter.substring(number, number + 1);

        if (letter != dni) {
            return false;

        } else {
            return true;
        }

    } else {
        return false;
    }
}

function gestionarCliente(inputContainer) {

    // Cuadrado rosa que informa para que se utiliza el DNI.
    // En principio siempre será el mismo numero de elementos en cada array por lo que utilizaremos el mismo bucle para lo mismo.
    const container_msn_dni = document.getElementsByClassName("container_msn_dni");
    const listElementsDocument = document.getElementsByClassName("gestion_documento");
    const listInputsCp = document.getElementsByClassName("gestion_cp");
    const containerElement = document.getElementsByClassName("container_element");
    const actualizadoCP = ActivadorBTN.findIndex((elementActivador) => elementActivador.nombre.toLocaleLowerCase() === "codigo_postal");
    const actualizadoDocument = ActivadorBTN.findIndex((elementActivador) => elementActivador.nombre.toLocaleLowerCase() === "documento");
    const containerCp = document.getElementsByName("Codigo_postal");
    const containerDocumento = document.getElementsByName("Documento");
    handleMoreText();

    if (inputContainer.value.toLowerCase() == "si") {
        for (let i = 0; i < container_msn_dni.length; ++i) {
            container_msn_dni[i].style.display = "block";
        }

        for (let i = 0; i < containerElement.length; ++i) {
            containerElement[i].style.display = "block";
        }

        // aparece DNI y desaparece codigo postal
        for (let index = 0; index < listInputsCp.length; ++index) {
            listInputsCp[index].style.display = "none";
            listInputsCp[index].childNodes[3].value = "";
            listInputsCp[index].childNodes[3].required = false;
        }

        for (let index = 0; index < listElementsDocument.length; ++index) {
            // le implementamos flex para que no rompa los estilos
            listElementsDocument[index].style.display = "grid";
        }

        for (let i = 0; i < containerCp.length; ++i) {
            containerCp[i].classList.remove("form-control-success");
        }

        listElementsDocument[1].childNodes[3].required = true;
        // listElementsDocument[3].childNodes[3].required = true;

        ActivadorBTN[actualizadoCP].value = true;
        ActivadorBTN[actualizadoDocument].value = false;
        validarBtn();

    } else if (inputContainer.value.toLowerCase() == "no") {

        for (let i = 0; i < container_msn_dni.length; ++i) {
            container_msn_dni[i].style.display = "none";
        }

        //alreves
        for (let index = 0; index < listInputsCp.length; ++index) {
            listInputsCp[index].style.display = "grid";
            listInputsCp[index].childNodes[3].required = true;
        }

        for (let index = 0; index < listElementsDocument.length; ++index) {
            listElementsDocument[index].style.display = "none";
        }

        for (let i = 0; i < containerDocumento.length; ++i) {
            containerDocumento[i].classList.remove("form-control-success");
        }

        for (let i = 0; i < containerElement.length; ++i) {
            containerElement[i].style.display = "block";
        }

        listElementsDocument[1].childNodes[3].value = "";
        listElementsDocument[1].childNodes[3].required = false;
        // listElementsDocument[3].childNodes[3].value = "";
        // listElementsDocument[3].childNodes[3].required = false;

        // Gestion de la validacion del boton al seleccionar NO es cliente
        ActivadorBTN[actualizadoCP].value = false;
        ActivadorBTN[actualizadoDocument].value = true;
        validarBtn();

    }

    window.userLabels.EDeclaratives.esCliente = inputContainer.value.toLowerCase();
}

//Funcion encargada de dar los estilos a los input según la validez de los datos implementados.
//Recibe como argumento el elemento y un buleano que valida el dato.
function validarInput(elemento, datoValidado) {

    const actualizado = ActivadorBTN.findIndex((elementActivador) => elementActivador.nombre.toLowerCase() === elemento.name.toLowerCase());
    const errorTexts = document.getElementsByClassName(`error__${elemento.name.toLowerCase()}`);

    if (!datoValidado) {
        elemento.classList.remove("form-control-success");
        elemento.classList.add("form-control-error");

        for (let indexErrText = 0; indexErrText < errorTexts.length; indexErrText++) {
            errorTexts[indexErrText].style.display = "block";
            errorTexts[indexErrText].innerHTML = ActivadorBTN[actualizado].errorText;
        }

        ActivadorBTN[actualizado].value = false;

    } else {
        elemento.classList.remove("form-control-error");
        elemento.classList.add("form-control-success");

        for (let indexErrText = 0; indexErrText < errorTexts.length; indexErrText++) {
            errorTexts[indexErrText].style.display = "none";
            errorTexts[indexErrText].innerHTML = "";
        }

        ActivadorBTN[actualizado].value = true;
    }

    validarBtn();
    implementaValorEnTodosLosForm(elemento);
}

function eventosDeValidacion(inputContainer) {

    inputContainer.addEventListener("input", function (event) {

        switch (inputContainer.name.toLowerCase()) {
            case "documento":
                validarDniNie(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);

                break;
            case "telefono":
                validarTelefono(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;
            case "email":
                validarEmail(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;
            case "nombre":
                validarNombreApellido(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;
            case "apellidos":

                validarNombreApellido(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;
            case "codigo_postal":
                validarCp(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;
            case "compañía_actual":
                gestionarNoCampaña(event.target.value);
                inputContainer.value != "" ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;
            case "vencimiento":
                validarVencimiento(event.target) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;
            case "jubilacion":
                validarJubilacion(event.target) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;
            default:
                break;
        }

        validarBtn();
    })
}

function validarBtn() {
    let element = ActivadorBTN.find(element => element.value == false)

    if (element == undefined || element == "undefined") {
        activarSubmitBtn();
    } else {
        desActivarBTNSubmit();
    }
}

// Esta funcion se encarga de la validacion general del formulario.
// observa los elementos seleccionados y actúa según el elemento introducido.
export function validacion(objBtnValidate) {
    ActivadorBTN = objBtnValidate;
    clickBotonDeshabilitado(ActivadorBTN);
    handleMoreText();
    HandleRingpool();
    gestionarEmpresas();
    handleTestJourney();
    handleCheckboxChange();

    document.addEventListener('click', handleValidator);
    document.addEventListener('touchstart', handleValidator);
    document.addEventListener('keydown', handleValidator);

    function handleValidator(event) {
        var inputElement = event.target;

        // Para validar el input el nombre tiene que estar en esta lista y el validador en el switch
        const inputListElements = ["Telefono", "Codigo_postal", "Documento", "email", "Nombre", "Apellidos", "Compañía_actual", "Vencimiento", "Jubilacion"];

        if (inputElement.type === 'radio') {
            gestionarCliente(inputElement);
            handleMoreText();
        }

        let isOk = inputListElements.includes(inputElement.name)
        if (isOk) {
            inputElement.autocomplete = "off";

            if (inputElement.name === "Vencimiento") {
                inputElement.min = new Date();
                inputElement.max = "9999-12-31";
            }

            eventosDeValidacion(inputElement);
        }

    };
}


// WEBPACK FOOTER //
// ./js/utils/modal/validation.js